import { render, staticRenderFns } from "./surplusMaterials.vue?vue&type=template&id=5e1ac7dd&scoped=true"
import script from "./surplusMaterials.vue?vue&type=script&lang=js"
export * from "./surplusMaterials.vue?vue&type=script&lang=js"
import style0 from "./surplusMaterials.vue?vue&type=style&index=0&id=5e1ac7dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ac7dd",
  null
  
)

export default component.exports